import { useId, type InputHTMLAttributes } from 'react';
import styles from './Switch.module.css';

export type SwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'role'> & {
  label: string;
  helperText?: string | undefined;
  labelDisplay?: 'visible' | 'hidden';
};

export const Switch = ({
  label,
  helperText,
  labelDisplay = 'visible',
  id,
  className,
  ...rest
}: SwitchProps) => {
  const generatedId = useId();
  const switchId = id ?? generatedId;
  return (
    <div className={[styles['field'], className ?? ''].join(' ')}>
      <label htmlFor={switchId} className={styles['row']}>
        <input
          id={switchId}
          type="checkbox"
          role="switch"
          className={styles['input']}
          aria-describedby={helperText ? `${switchId}-helper` : undefined}
          {...rest}
        />
        <span className={labelDisplay === 'hidden' ? 'visually-hidden' : styles['label']}>{label}</span>
        <span className={styles['track']} aria-hidden="true" />
      </label>
      {helperText ? (
        <span id={`${switchId}-helper`} className={styles['helper']}>
          {helperText}
        </span>
      ) : null}
    </div>
  );
};
